import {
    Container,
    Title,
    SimpleGrid,
    Card,
    Image,
    Text,
    Badge,
    Button,
    Group,
} from "@mantine/core";
import { IconBrandGithub, IconExternalLink } from "@tabler/icons-react";
import { motion } from "framer-motion";
import classes from "./Portfolio.module.css";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const cardVariants = {
    hidden: { y: 60, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 80,
            damping: 12,
        },
    },
};

export function Portfolio({ data }) {
    return (
        <section className={classes.section} id='portfolio'>
            <Container size='lg'>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}>
                    <Title
                        order={2}
                        className={classes.title}
                        ta='center'
                        mb='xl'>
                        Portfolio
                    </Title>

                    <Text
                        size='lg'
                        ta='center'
                        mb={50}
                        c='dimmed'
                        maw={700}
                        mx='auto'>
                        Výběr z mých nedávných projektů, které demonstrují mé
                        schopnosti a zkušenosti.
                    </Text>
                </motion.div>

                <div className={classes.projectsWrapper}>
                    <motion.div
                        variants={containerVariants}
                        initial='hidden'
                        whileInView='visible'
                        viewport={{ once: true, amount: 0.2 }}>
                        <SimpleGrid
                            cols={{
                                base: 1,
                                sm: data.projects.length === 2 ? 2 : 3,
                            }}
                            spacing='xl'
                            className={
                                data.projects.length === 2
                                    ? classes.twoProjects
                                    : ""
                            }>
                            {data.projects.map((project) => (
                                <motion.div
                                    key={project.id}
                                    variants={cardVariants}>
                                    <Card
                                        shadow='sm'
                                        padding='lg'
                                        radius='md'
                                        className={classes.card}>
                                        <Card.Section>
                                            <div
                                                className={
                                                    classes.imageWrapper
                                                }>
                                                <Image
                                                    src={project.image}
                                                    height={200}
                                                    alt={project.title}
                                                    fallbackSrc='https://placehold.co/600x400/1a1b1e/ffffff?text=Project'
                                                />
                                                {project.featured && (
                                                    <Badge
                                                        className={
                                                            classes.badge
                                                        }
                                                        variant='gradient'
                                                        gradient={{
                                                            from: "blue",
                                                            to: "cyan",
                                                        }}>
                                                        Featured
                                                    </Badge>
                                                )}
                                            </div>
                                        </Card.Section>

                                        <Title
                                            order={3}
                                            size='h4'
                                            mt='md'
                                            mb='xs'>
                                            {project.title}
                                        </Title>

                                        <Text size='sm' c='dimmed' mb='md'>
                                            {project.description}
                                        </Text>

                                        <Group gap={5} mb='md'>
                                            {project.technologies.map(
                                                (tech, idx) => (
                                                    <Badge
                                                        key={idx}
                                                        variant='light'
                                                        size='sm'>
                                                        {tech}
                                                    </Badge>
                                                )
                                            )}
                                        </Group>

                                        <Group gap='xs'>
                                            {project.github && (
                                                <Button
                                                    component='a'
                                                    href={project.github}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    variant='light'
                                                    leftSection={
                                                        <IconBrandGithub
                                                            size={16}
                                                        />
                                                    }
                                                    size='sm'
                                                    flex={1}>
                                                    Code
                                                </Button>
                                            )}
                                            {project.link && (
                                                <Button
                                                    component='a'
                                                    href={project.link}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    variant='filled'
                                                    leftSection={
                                                        <IconExternalLink
                                                            size={16}
                                                        />
                                                    }
                                                    size='sm'
                                                    flex={1}>
                                                    Demo
                                                </Button>
                                            )}
                                        </Group>
                                    </Card>
                                </motion.div>
                            ))}
                        </SimpleGrid>
                    </motion.div>
                </div>
            </Container>
        </section>
    );
}
